<template>
  <div id="app">
    <img alt="TOYA SP. z o.o. LOGO" src="./assets/logo.png">
    <Alert v-on:logged="setFooterVersionOn" v-on:loggedOut="setFooterVersionOff"/>
    <div class="footer">Grupa TOYA © 2022 {{version}} </div>
  </div>
</template>

<script>
import Alert from './components/Alert.vue';
export default {
  name: 'App',
  components: {
    Alert
  },
  methods: {
    setFooterVersionOn: function(){
      this.version = 'v1.3';
    },
    setFooterVersionOff: function(){
      this.version = '';
    },
  },
  data: function(){
    return{
      version: '',
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  min-height: 100vh;
  img{
    max-height: 50px;
    object-fit: cover;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .footer {
    position: absolute;
    font-size: 15px;
    font-family: 'Roboto', sans-serif;
    color: #AAAAAA;
    width: 200px;
    bottom: 15px;
    left: 50%;
    margin-left: -100px;
  }
}
</style>
